export default __webpack_public_path__ + "static/media/1992.832a17fe.png";